import { ScrollSpy, ScrollSpyItem } from '@toggle/design-system';
import React from 'react';

import * as S from './Sidebar.styles';

export const Sidebar = ({
  containerRef,
  items,
}: {
  containerRef: React.RefObject<HTMLElement | null>;
  items: ScrollSpyItem[];
}) => {
  return (
    <S.SidebarContainer>
      <ScrollSpy items={items} containerRef={containerRef} />
    </S.SidebarContainer>
  );
};
